import React from 'react';
import Grid from '@mui/material/Grid';
// import Carousel from 'react-multi-carousel';
import { isEmpty, map, take } from 'lodash';
import 'react-multi-carousel/lib/styles.css';

import RecentDevelopmentItem from './recent-development-item';

// const responsive = {
//   desktop: {
//     breakpoint: { max: 3000, min: 1024 },
//     items: 5,
//     partialVisibilityGutter: 20,
//   },
//   tablet: {
//     breakpoint: { max: 1024, min: 464 },
//     items: 3,
//     partialVisibilityGutter: 20,
//   },
//   mobile: {
//     breakpoint: { max: 464, min: 0 },
//     items: 1,
//     partialVisibilityGutter: 20,
//   },
// };

// const RecentDevelopmentsCarousal = (props) => {
//   const { data } = props;
//
//   if (isEmpty(data)) return null;
//
//   const dataToShow = size(data) > 6 ? data.slice(0, 6) : data;
//
//   return (
//     <Carousel partialVisible={true} responsive={responsive} ssr={true}>
//       {map(dataToShow, (stat) => <RecentDevelopmentItem stat={stat} key={uniqueId('recentDev_')}/>)}
//     </Carousel>
//   );
// };

const RecentDevelopmentsCarousal = (props) => {
  const { data } = props;

  if (isEmpty(data)) return null;

  const dataToShow = take(data, 5);
  return (
    <Grid container>
      {map(dataToShow, (rd) => (
        <Grid item key={`recentDev_${rd.link}`} xs={12} sm={6} md={2.4}>
          <RecentDevelopmentItem stat={rd}/>
        </Grid>
      ))}
    </Grid>
  );
};

export default RecentDevelopmentsCarousal;
